import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NotAdmin.css'; 
import { auth } from '../lib/firebase';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

const NotAdmin = ({ userName, profilePictureUrl }) => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  useEffect(() => {
    const checkRole = async () => {
      if (user) {
        try {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const userData = docSnap.data();
            if (userData.role === 'admin') {
              // Redirect to the appropriate route if the user is an admin
              navigate('/'); 
            }
          }
        } catch (error) {
          console.error('Error fetching user role:', error);
        }
      }
    };

    checkRole();
  }, [user, navigate]);

  const handleLogout = () => {
    // Sign out the user and handle any errors
    signOut(auth).catch((error) => {
      console.error('Error signing out:', error);
    });
  };

  return (
    <div className="not-admin-container">
      <div className="not-admin-content">
        <img 
          src={profilePictureUrl} 
          alt="User" 
          className="not-admin-profile-picture" 
        />
        <h1 className="not-admin-message">
          Hi {userName}, you do not have the admin privileges and do not have access to this portal.
        </h1>
        <button onClick={handleLogout} className="not-admin-logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default NotAdmin;
